module.exports = __webpack_public_path__ + "static/woman_set_2preschool.a16ad6aa.svg";